module.exports = __webpack_public_path__ + "files/7f81434cd4a7d02b30e4185f78743a53.png";